import React from 'react';
import Relay from 'react-relay';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import {FormattedMessage, defineMessages, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import {sendToExtension} from '../app/ExtensionCommunicate';
import DeleteButton from '../fw/DeleteButton.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    dialogTitle: {id: 'ChannelViewParent.deleteButton.title', defaultMessage: 'Disconnect Application'},
    dialogMessage: {id: 'ChannelViewParent.deleteButton.message', defaultMessage: 'Do you really want to disconnect "{application}"? All screens, cached data and logged API requests will be deleted too.'},
    dialogButton: {id: 'ChannelViewParent.deleteButton.button', defaultMessage: 'Disconnect'},
});

interface ChannelViewParentProps {
 cancel?: (...args: unknown[]) => unknown | boolean;
 createCallback?: (...args: unknown[]) => unknown;
 intl?: object;
 relay?: object;
 user: User;
 wrapper?: boolean;
}

export default class ChannelViewParent extends React.Component<ChannelViewParentProps> {
    typeName = 'channels';

    static propTypes = {
        cancel: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        createCallback: PropTypes.func,
        intl: PropTypes.object,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
        wrapper: PropTypes.bool
    };

    static defaultProps = {
        wrapper: false
    };

    static contextTypes = {
        router: PropTypes.object
    };

    onDeleteSuccess() {
        /* inform extension to reload its configuration */
        sendToExtension({
            message: 'dativery-reload',
        });

        // dont wait on extension reload for redirecting
        let path = urlMapping.getUrl(types['organisations'], "view",  this.props.user.organisation);
        this.context.router.push(path);
    }

    getDeleteButton({data, type, deleteTitle, beforeDelete}) {
        return (<DeleteButton
            beforeDelete={() => {
                if (beforeDelete) {
                    return beforeDelete();
                }

                return true;
            }}
            confirmDialogConfig={{
                title: this.props.intl.formatMessage(messages.dialogTitle),
                message: this.props.intl.formatMessage(messages.dialogMessage, {application: data.channelDef.name}),
                button: this.props.intl.formatMessage(messages.dialogButton),
            }}
            data={data}
            deleteFatQuery={Relay.QL `fragment on DeleteChannelPayload {
                                            updatedNode {
                                                id
                                            },
                                            organisation {
                                                channels(first: 100, deleted: false) {
                                                    edges {
                                                        node {
                                                            id,
                                                            realId
                                                        }
                                                    }
                                                }
                                            }

                                        }`}
            deleteMutation={Relay.QL `mutation { deleteChannel }`}
            disconnect
            key="7"
            metadata={type}
            onSuccess={() => { this.onDeleteSuccess(); }}
            organisationId={data.organisation_id}
            redirectToParent
            title={deleteTitle || <FormattedMessage defaultMessage="Disconnect" id="channel.disconnect" />}
            types={types}
            urlMapping={urlMapping}
        />);
    }

    getName(channel) {
        const data = channel || this.props.user.organisation.channel;

        //const type = types[this.typeName];
        // return type.getDefaultTitle(data);

        let title = data.channelDef.name;
        if (data.name) {
            title += ' - ' + data.name;
        }

        return title;
    }

    getBreadcrum() {
        const data = this.props.user.organisation.channel;
        const type = types[this.typeName];

        return [
            {type, data},
            {type: types['scenarios'], data: this.props.user.scenario},
            {type: types['organisations'], data: this.props.user.organisation}
        ];
    }
}
